import useAuth from "../login/AuthContext";
import { useSelectedNetworkImportTypes } from "../../hooks/useSelectedNetworkImportType";
import { URL } from "../../constants/navigation";

const UserContainer = ({ children }) => children;

export const getUserLinks = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { isEntrata, isAcc, isRms } = useSelectedNetworkImportTypes();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { isSuperAdmin, isWriteAccess } = useAuth();

  const userLinks = [{ name: "Invite", url: URL.USERS_INVITE }];
  // const userLinks = [{ name: "Report", url: USERS_REPORT_URL }];

  if (isWriteAccess()) {
    if (!isEntrata && !isAcc && !isRms) {
      userLinks.push({ name: "Remove", url: URL.USERS_REMOVE });
    } else if (isSuperAdmin()) {
      userLinks.push({ name: "Remove", url: URL.USERS_REMOVE });
    }
  }

  userLinks.push({ name: "Search", url: URL.USERS_SEARCH });

  if (isWriteAccess()) {
    userLinks.push({ name: "Match", url: URL.USERS_MATCH });
  }

  // Add Send to Entrata for Entrata networks
  if (isEntrata && isWriteAccess()) {
    userLinks.push({ name: "Send to Entrata", url: URL.SEND_TO_ENTRATA });
  }

  return userLinks;
};

export default UserContainer;
